import styled from 'styled-components'

export const FormWrapper = styled.div`
  padding: 25px 0 15px 0;
`
